/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitGetEntityHoneypotsAggQueries
 */
export interface MonitGetEntityHoneypotsAggQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityHoneypotsAggQueries
     */
    process_id?: string;
}

/**
 * Check if a given object implements the MonitGetEntityHoneypotsAggQueries interface.
 */
export function instanceOfMonitGetEntityHoneypotsAggQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityHoneypotsAggQueriesFromJSON(json: any): MonitGetEntityHoneypotsAggQueries {
    return MonitGetEntityHoneypotsAggQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityHoneypotsAggQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityHoneypotsAggQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
    };
}

export function MonitGetEntityHoneypotsAggQueriesToJSON(value?: MonitGetEntityHoneypotsAggQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
    };
}

